import React, { useEffect }from "react";
import EditForm from "../EditForm";
import { Input } from "postcss";
import InputField from "../InputField";
import Switch from "../Switch";

const DetailsTab = ({ agreement, setAgreement, setHasChanges }) => {
  console.log("Agreement in DetailsTab:", agreement);

  useEffect(() => {
  if (agreement?.domainOwnerIdentifiersCsv) {
    const trimmed = agreement.domainOwnerIdentifiersCsv.trim();
    if (trimmed !== agreement.domainOwnerIdentifiersCsv) {
      setAgreement(prev => ({
        ...prev,
        domainOwnerIdentifiersCsv: trimmed,
      }));
      setHasChanges(true);
    }
  }
}, [agreement?.domainOwnerIdentifiersCsv]);

  return (
    <>
    <h2>General</h2>
      <EditForm
        data={agreement}
        setData={setAgreement}
        setHasChanges={setHasChanges}
        disabled={false}
        fields={[
          { key: "name", label: "Name", type: "text" },
          {
            key: "officeBranch",
            label: "Office branch",
            type: "dropdown",
            options: [
              { value: "Angelholm", label: "Angelholm" },
              { value: "Gothenburg", label: "Gothenburg" },
              { value: "Stockholm", label: "Stockholm" },
            ],
          },
          { key: "invoicingPeriod", label: "Invoicing period", type: "dropdown", options: [
            { value: "monthly", label: "Monthly" },
            { value: "quarterly", label: "Quarterly" },
          ]},
          {
            key: "customerType",
            label: "Customer type",
            type: "dropdown",
            options: [
              { value: "A", label: "A" },
              { value: "B", label: "B" },
              { value: "C", label: "C" },
              { value: "D", label: "D" },
            ],
          },
          {
            key: "status",
            label: "Status",
            type: "dropdown",
            options: [
              { value: "Active", label: "Active" },
              { value: "Inactive", label: "Inactive" },
            ],
          },
          { key: "domainOwnerIdentifiersCsv", label: "Name SRS Id(s)", type: "text"},
          {
            key: "updatedBy",
            label: "Updated By",
            type: "text",
            disabled: true,
          },
          {
            key: "updatedDateTimeUTC",
            label: "Updated date",
            type: "date",
            disabled: true,
          }
        ]}
      />

      <h2 className="mt-2">Meetings</h2>
      <EditForm
        data={agreement}
        setData={setAgreement}
        setHasChanges={setHasChanges}
        disabled={false}
        fields={[
          {
            key: "hasAlignmentMeeting",
            label: "Alignment meeting",
            type: "switch",
            disabled: false,
          },
          {
            key: "hasTacticalMeeting",
            label: "Tactical meeting",
            type: "switch",
            disabled: false,
          },
          {
            key: "alignmentMeetingComment",
            label: "Comment",
            type: "textarea",
            disabled: false,
          },
          {
            key: "tacticalMeetingComment",
            label: "Comment",
            type: "textarea",
            disabled: false,
          },
          {
            key: "hasStrategicMeeting",
            label: "Strategic meeting",
            type: "switch",
            disabled: false,
          },
          {
            key: "hasOperationalMeeting",
            label: "Operational meeting",
            type: "switch",
            disabled: false,
          },
          {
            key: "strategicMeetingComment",
            label: "Comment",
            type: "textarea",
            disabled: false,
          },
          {
            key: "operationalMeetingComment",
            label: "Comment",
            type: "textarea",
            disabled: false,
          }          
        ]}
      />

    </>
  );
};

export default DetailsTab;
